"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataManipulation = dataManipulation;
exports.queryComment = queryComment;
exports.updateAudit = updateAudit;
exports.updateSeq = updateSeq;
var _request = _interopRequireDefault(require("@/utils/request"));
function queryComment(data) {
  return (0, _request.default)({
    url: 'cms/manage/comment/query',
    method: 'post',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}
function updateSeq(data, id) {
  return (0, _request.default)({
    url: 'cms/manage/comment/seq/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}
function updateAudit(data, id) {
  return (0, _request.default)({
    url: 'cms/manage/comment/audit/' + id,
    method: 'put',
    headers: {
      "x-access-token": window.localStorage.getItem('token')
    },
    data: data
  });
}

/**
 * 前端刷新公共方法
 */
function dataManipulation(tableData, id, line, audit, roofPlacement, updateTime, updateUser) {
  tableData.map(function (element) {
    //如果是单选的直接用if判断id是否相等就可以了,如果是复选框的就需要嵌套for循环判断
    if (element.id == id) {
      if (updateUser != null && updateUser != "") {
        element.updateUser = updateUser;
      }
      if (updateTime != null && updateTime != "") {
        element.updateTime = updateTime;
      }
      if (line != null && line != "") {
        element.line = line;
      }
      if (audit != null && audit != "") {
        element.audit = audit;
      }
      if (roofPlacement != null && roofPlacement != "") {
        element.roofPlacement = roofPlacement;
      }
    }
  });
  return tableData;
}